import {Context} from '@gongxigames/framework/core/fragments/BuilderX/types';
import {Component, ComponentProps, TweenConfig} from './Component';
import {Sprite} from 'pixi.js';
import {MovieClip, Animation} from '@gongxigames/framework/core/fragments/display';
import {MovieClipTween} from '@gongxigames/framework/core/fragments/tween/MovieClipTween';

export type FrameAnimationProps = ComponentProps & {
    fps?: number;
    delay?: number;
    repeat?: number|string;
    tweens?: TweenConfig[];
};

export class FrameAnimation extends Component<FrameAnimationProps, Animation> {
    public readonly jsxType: string = 'frame_animation';

    public propsToJson(): any {
        const result = super.propsToJson();

        result.frames = result.children;
        delete result.children;

        return result;
    }

    public clone(): FrameAnimation {
        return new FrameAnimation(this.props);
    }

    public getConstructor(): new () => any {
        return Animation;
    }

    public getChildrenToPixi(): Component<ComponentProps>[] {
        return [];
    }

    public updateBaseProps(context: Context, container: Sprite, element: Animation): void {
        const {fps, delay, repeat, tweens} = this.props;
        const movieClip = this.buildMovieClip(context);
        const movieClipTween = new MovieClipTween(movieClip, fps || 20);

        movieClipTween.delay(delay || 0).repeat(this.getRepeat(repeat));

        element.addTween(movieClipTween);
        element.container.addChild(movieClip);

        if (tweens) {
            this.createTweenAnimation(movieClip, element, tweens);
        }

        super.updateBaseProps(context, movieClip, element);
    }

    public buildMovieClip(context: Context): MovieClip {
        const props = this.props;

        if (!props.children) {
            throw new Error('MovieClip should contain children');
        }

        const children = props.children as any as Component<ComponentProps>[];
        const movieClip = new MovieClip();

        const frames = children.map((item, i) => item.build({context}));

        movieClip.setFrames(frames as Sprite[]);

        return movieClip;
    }
}
